import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { BackendResponse } from 'src/app/core/interfaces/shared.interface';

import { SharedService } from 'src/app/core/services/shared.service';
import { SelfPublishTag } from 'src/app/modules/companies/companies.interface';
import { TagsService } from '../../modules/tags/tags.service';
import * as TagsActions from './tags.actions';

@Injectable()
export class TagsEffects {
  loadTags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TagsActions.request.loadTags),
      switchMap(() => {
        return this.tagsService
          .getSelfPublishTags()
          .pipe(map((tags: BackendResponse<SelfPublishTag>) => TagsActions.setTags({ tags: tags.results })));
      })
    )
  );

  createTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TagsActions.request.createTag),
      switchMap(({ name }) => {
        return this.tagsService.createSelfPublishTag(name).pipe(map((tag: SelfPublishTag) => TagsActions.addTag({ tag })));
      })
    )
  );

  deleteTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TagsActions.request.deleteTag),
      switchMap(({ id }) => {
        return this.tagsService.deleteSelfPublishTag(id).pipe(map(() => TagsActions.deleteTag({ id })));
      })
    )
  );

  constructor(private actions$: Actions, private sharedService: SharedService, private tagsService: TagsService) {}
}
